module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-body",
    on: {
      "click": function($event) {
        _vm.clickBody()
      }
    }
  }, [(_vm.currModule == 'home' || _vm.currModule === 'profileimg') ? [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('router-view')], 1)])] : [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('widget-breadcrumb', {
    attrs: {
      "fontIcon": _vm.fontIcon,
      "currModule": _vm.currModule,
      "currCodapp": _vm.currCodapp,
      "nameModule": _vm.nameModule,
      "descCodapp": _vm.descCodapp,
      "codapp": _vm.codapp,
      "descModule": _vm.descModule
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('widget-license-flash-message'), _vm._v(" "), _c('widget-flash-message'), _vm._v(" "), _c('router-view')], 1)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28fb7bac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/DashBody.vue
// module id = 3644
// module chunks = 1